import { GeschaedigtesGeraet } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_GESCHAEDIGTE_GERAETE_KOMPLEX = 'GESCHAEDIGTE-GERAETE-KOMPLEX';

export interface GeschaedigteGeraeteKomplexModelConfig extends DynamicFormValueControlModelConfig<GeschaedigtesGeraet[]> {
}

export class GeschaedigteGeraeteKomplexModel extends DynamicFormValueControlModel<GeschaedigtesGeraet[]> {
  @serializable() readonly type: string = TYPE_GESCHAEDIGTE_GERAETE_KOMPLEX;

  constructor(config: GeschaedigteGeraeteKomplexModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
  }
}
